import React, { useState } from "react";
import excel from "../../../assets/common/excel.svg";
import uploadColored from "../../../assets/common/uploadColored.svg";
import listFailed from "../../../assets/common/listFailed.svg";
import { RespFont, TextWithPic } from "../../common/Style";
import { useDispatch, useSelector } from "react-redux";
import { addMany } from "../../../store/reducers/guestsReducer";
import { toast } from "react-toastify";
import readXlsxFile from "read-excel-file";
import OpacityLoading from "../../common/loader/OpacityLoading";
import { exportToCSV } from "../../common/others/Functions";

const AddExcel = ({ init }) => {
  const { guestsLoading } = useSelector((state) => state.guestsReducer);

  const dispatch = useDispatch();
  const [errors, setErrors] = useState(false);

  const fileSelected = (event) => {
    readXlsxFile(event.target.files[0]).then((rows) => {
      dispatch(addMany({ rows })).then((res) => {
        if (!res.payload?.error) {
          toast.success("הפעולה בוצעה בהצלחה");
          init();
        } else {
          setErrors(res.payload?.error);
          toast.error("ישנן מספר שגיאות, יש להוריד את הקובץ ולפעול בהתאם");
        }
      });
    });
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-evenly",
        alignItems: "center",
        width: "100%",
        height: "100%",
      }}
    >
      <a
        onClick={(e) => e.stopPropagation()}
        href="https://secret-mqr-upload.s3.eu-central-1.amazonaws.com/wedding/sys/tav.xlsx"
        style={{ textDecoration: "none", color: "inherit" }}
        target="_blank"
        rel="noopener noreferrer"
        download
      >
        <TextWithPic style={{ flexDirection: "column", padding: "15px 30px" }}>
          <RespFont csize={"22px"} psize={"20px"}>
            תבנית
          </RespFont>
          <img
            src={excel}
            alt="excel"
            style={{ width: "50px", marginTop: "20px" }}
          />
        </TextWithPic>
      </a>
      <div onClick={(e) => e.stopPropagation()}>
        <label htmlFor="file-upload">
          <TextWithPic
            style={{ flexDirection: "column", padding: "15px 25px" }}
          >
            <RespFont csize={"22px"} psize={"20px"}>
              העלאה
            </RespFont>
            <img
              src={uploadColored}
              alt="uploadColored"
              style={{ width: "60px", marginTop: "10px" }}
            />
          </TextWithPic>
        </label>
        <input
          id="file-upload"
          type="file"
          onChange={fileSelected}
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        />
      </div>
      {errors && (
        <TextWithPic
          onClick={(e) => {
            e.stopPropagation();
            exportToCSV(errors, "שגיאות");
          }}
          style={{ flexDirection: "column", padding: "15px 25px" }}
        >
          <RespFont csize={"22px"} psize={"20px"}>
            שגיאות
          </RespFont>
          <img
            src={listFailed}
            alt="listFailed"
            style={{ width: "55px", marginTop: "10px" }}
          />
        </TextWithPic>
      )}

      {guestsLoading && <OpacityLoading />}
    </div>
  );
};

export default AddExcel;
